
import ColorTemperatureSwatch from '~/components/ColorTemperatureSwatch'
import VehicleBulbBadge from '~/components/VehicleBulbBadge'
import cartMixin from '~/mixins/cartMixin'
import commercialOperationPrice from '~/mixins/commercialOperationPrice'
import { bulbSpecs } from '~/utils/vehicleBulbList'
import { openIntent } from '~/utils/openIntent'
import { writeProductCartContext } from '~/utils/productCartContextStorage'

export default {
  name: 'VehicleBulbListItem',
  components: { ColorTemperatureSwatch, VehicleBulbBadge },
  directives: { openIntent },
  mixins: [cartMixin, commercialOperationPrice],
  props: {
    product: { type: Object, required: true },
    cartMetadata: { type: Object, default: null },
    badge: { type: String, default: null },
  },
  computed: {
    operationPrice() {
      return this.operationPriceOf(this.product, { beforeTax: false })
    },
    specs() {
      return bulbSpecs(this.product.variant, this.$i18n.locale)
    },
    productLink() {
      return this.localePath({
        name: 'produit-slug',
        params: { slug: this.product.slug },
      })
    },
    imageSrc() {
      const image =
        this.product.variant?.images?.[0] || this.product.images?.[0]
      if (!image) return null
      return this.$cropUrl(image, 240, 240, image.extension, 86)
    },
    hasDiscount() {
      return (
        this.product.variant.user_price_ttc < this.product.variant.price_ttc
      )
    },
    canAddToCart() {
      const variant = this.product.variant
      if (!variant) return false
      if (this.product.use_alternative_variants_layout) return false
      if ((this.product.selectable_variants || []).length >= 2) return false
      return (
        variant.quantity_available > 0 ||
        (variant.out_of_stock_status_id > 1 &&
          variant.out_of_stock_status_id < 4)
      )
    },
  },
  methods: {
    onAddToCart() {
      this.addToCart(this.product, this.product.variant, 1, this.cartMetadata)
    },
    rememberCartContext() {
      writeProductCartContext(this.product.id, this.cartMetadata)
    },
    openProduct() {
      this.rememberCartContext()
      this.trackOperationBadgeProductClick(this.product, this.operationPrice)
    },
  },
}
